

























































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

@Component
export default class DocsSearchList extends Vue {
  // Props

  @Prop({ required: true })
  public searchResults!: object[];

  @Prop({ required: true })
  public query!: string;

  @Prop({ required: true })
  public isLoading!: boolean;

  // Methods

  public getExcerpt(doc: object) {
    return _.get(doc, "_highlightResult.excerpt.value", "");
  }
}
